export const getShareShopEmailSubject = ({ userName, storeName }) =>
  userName
    ? `${userName} wants you to check out ${storeName}`
    : `You have been invited to check out ${storeName}`;

export const getShareShopEmailBody = ({ userName, storeName }) =>
  userName
    ? `${userName} wants to share ${storeName} with you! You’ll find the shop stocked with a variety of items. Happy browsing!\n\n`
    : `Check out ${storeName}! You’ll find the shop stocked with a variety of items. Happy browsing!\n\n`;
